import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "../about-upsc/about-upsc.module.css";
import Link from 'next/link';


const About_Civil_Service = () => {

    const list =[
        {listcont:"Current events of national and international importance"},
        {listcont:"History of India and the Indian National Movement"},
        {listcont:"Indian and World Geography-Physical, Social and Economic Geography of India and the World"},
        {listcont:"Indian Polity and Governance-Constitution, Political System, Panchayati Raj, Public Policy, Rights Issues, etc."},
        {listcont:"Economic and Social Development-Sustainable Development, Poverty, Inclusion, Demographics, Social Sector initiatives, etc."},
        {listcont:"General issues on Environmental Ecology, Bio-diversity and Climate Change - that do not require subject specialization."},
        {listcont:"General Science."}
      ]
      const secondlist =[
        {list:"Comprehension"},
        {list:"Interpersonal skills including communication skills"},
        {list:"Logical reasoning and Analytical ability"},
        {list:"Decision-making and Problem-solving"},
        {list:"General mental ability"},
        {list:"Decision-making and Problem-solving"},
        {list:"Basic numeracy (numbers and their relations, orders of magnitude, etc.) (Class X level), Data interpretation (charts, graphs, tables, data sufficiency etc.(Class X level)."}
      ]
    
      const thirdlist =[
        {list:"Indian culture will cover the salient aspects of Art Forms, Literature and Architecture from ancient to modern times."},
        {list:"Modern Indian history from about the middle of the eighteenth century until the present- significant events, personalities and issues."},
        {list:"The Freedom Struggle - its various stages and important contributors /contributions from different parts of the country."},
        {list:"Post-independence consolidation and reorganization within the country."},
        {list:"History of the world will include events from 18th century such as the industrial revolution, world wars, redrawal of national boundaries, colonization, decolonization, political philosophies like communism, capitalism, socialism etc. their forms and effect on the society."},
        {list:"Salient features of the Indian Society Diversity of India."},
        {list:"Role of women and women’s organizations, population and associated issues, poverty and developmental issues, urbanization, their problems and their remedies."},
        {list:"Effects of globalization on the Indian society. Social empowerment, communalism, regionalism and secularism."},
        {list:"Salient features of world’s physical geography."},
        {list:"Distribution of key natural resources across the world (including South Asia and the Indian subcontinent); factors responsible for the location of primary, secondary, and tertiary sector industries in various parts of the world (including India)"},
        {list:"Important Geophysical phenomena such as earthquakes, Tsunami, Volcanic activity, cyclone etc., geographical features and their location- changes in critical geographical features (including water bodies and ice-caps) and in flora and fauna and the effects of such changes."}
      ]
    
      const fourthlist =[
        {list:"Indian Constitution- historical underpinnings, evolution, features, amendments, significant provisions and basic structure."},
        {list:"Functions and responsibilities of the Union and the States, issues and challenges pertaining to the federal structure, devolution of powers and finances up to local levels and challenges therein."},
        {list:"Separation of powers between various organs dispute redressal mechanisms and institutions."},
        {list:"Comparison of the Indian constitutional scheme with that of other countries"},
        {list:"Parliament and State Legislatures - structure, functioning, conduct of business, powers & privileges and issues arising out of these."},
        {list:"Structure, organization and functioning of the Executive and the Judiciary Ministries and Departments of the Government; pressure groups and formal/informal associations and their role in the Polity."},
        {list:"Salient features of the Representation of People’s Act."},
        {list:"Appointment to various Constitutional posts, powers, functions and responsibilities of various Constitutional Bodies."},
        {list:"Statutory, regulatory and various quasi-judicial bodies"},
        {list:"Government policies and interventions for development in various sectors and issues arising out of their design and implementation."},
        {list:"Development processes and the development industry- the role of NGOs, SHGs, various groups and associations, donors, charities, institutional and other stakeholders"},
        {list:"Welfare schemes for vulnerable sections of the population by the Centre and States and the performance of these schemes; mechanisms, laws, institutions and Bodies constituted for the protection and betterment of these vulnerable sections."},
        {list:"Issues relating to development and management of Social Sector/Services relating to Health, Education, Human Resources."},
        {list:"Issues relating to poverty and hunger."},
        {list:"Important aspects of governance, transparency and accountability, e-governance- applications, models, successes, limitations, and potential; citizens charters, transparency & accountability and institutional and other measures."},
        {list:"Role of civil services in a democracy."},
        {list:"India and its neighborhood-relations."},
        {list:"Bilateral, regional and global groupings and agreements involving India and/or affecting India’s interests"},
        {list:"Effect of policies and politics of developed and developing countries on India’s interests, Indian diaspora."},
        {list:"Important International institutions, agencies and fora- their structure, mandate."}
      ]
    
      const fifthlist =[
        {list:"Indian Economy and issues relating to planning, mobilization of resources, growth, development and employment."},
        {list:"Inclusive growth and issues arising from it."},
        {list:"Government Budgeting."},
        {list:"Major crops cropping patterns in various parts of the country, different types of irrigation and irrigation systems storage, transport and marketing of agricultural produce and issues and related constraints; etechnology in the aid of farmers"},
        {list:"Issues related to direct and indirect farm subsidies and minimum support prices; Public Distribution System- objectives, functioning, limitations, revamping; issues of buffer stocks and food security;"},
        {list:"Technology missions; economics of animal-rearing."},
        {list:"Food processing and related industries in India- scope and significance, location, upstream and downstream requirements, supply chain management."},
        {list:"Land reforms in India."},
        {list:"Effects of liberalization on the economy, changes in industrial policy and their effects on industrial growth."},
        {list:"Infrastructure: Energy, Ports, Roads, Airports, Railways etc."},
        {list:"Investment models."},
        {list:"Science and Technology - developments and their applications and effects in everyday life"},
        {list:"Achievements of Indians in science & technology; indigenization of technology and developing new technology."},
        {list:"Awareness in the fields of IT, Space, Computers, robotics, nano-technology, bio-technology and issues relating to intellectual property rights."},
        {list:"Conservation, environmental pollution and degradation, environmental impact assessment"},
        {list:"Disaster and disaster management."},
        {list:"Linkages between development and spread of extremism."},
        {list:"Role of external state and non-state actors in creating challenges to internal security."},
        {list:"Challenges to internal security through communication networks, role of media and social networking sites in internal security challenges, basics of Cyber security; money- laundering and its prevention"},
        {list:"Security challenges and their management in border areas; linkages of organized crime with terrorism"},
        {list:" Various Security forces and agencies and their mandate."}
      ]
    
      const sixthlist =[
        {list:"Attitude: content, structure, function; its influence and relation with thought and behaviour; moral and political attitudes; social influence and persuasion."},
        {list:"Aptitude and foundational values for Civil Service, integrity, impartiality and non- partisanship, objectivity, dedication to public service, empathy, tolerance and compassion towards the weaker sections."},
        {list:"Emotional intelligence-concepts, and their utilities and application in administration and governance."},
        {list:"Contributions of moral thinkers and philosophers from India and world."},
        {list:"Public/Civil service values and Ethics in Public administration: Status and problems; ethical concerns and dilemmas in government and private institutions; laws, rules, regulations and conscience as sources of ethical guidance; accountability and ethical governance; strengthening of ethical and moral values in governance; ethical issues in international relations and funding; corporate governance."},
        {list:"Probity in Governance: Concept of public service; Philosophical basis of governance and probity;"},
        {list:"Information sharing and transparency in government, Right to Information, Codes of Ethics, Codes of Conduct, Citizen’s Charters, Work culture, Quality of service delivery, Utilization of public funds, challenges of corruption."},
        {list:" Case Studies on above issues."} 
      ]
        
  return (
    <>
                     <div className="container">
                        <div className="row">
                            <div className="col">
                                <h2 className={`${styles.sectiontitle} mb-0`}>Preliminary Examination Syllabus</h2>
                                <p className={`${styles.aboutheading1} mb-0 pt-md-2`}>Paper I - General Studies</p>

                                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                    {list.map((item,index)=>(
                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            {item.listcont}
                                            </p>
                                        </div>
                                    </li>
                                    ))}
                                    
                                </ul>

                                <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper II - CSAT</p>
                                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                    {secondlist.map((item,index)=>(
                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                            {item.list}
                                            </p>
                                        </div>
                                    </li>
                                    ))}
                                    
                                </ul>
        
                            </div>
                        </div>
                   </div> 

                   <div className="container pt-3">
                        <div className="row">
                            <div className="col" style={{color: "#DB1B0D"}}>
                                <p className="">Note 1: The questions will be of multiple choice, objective type.</p>
                                <p className="">Note 2: It is mandatory for the candidate to appear in both the Papers
                                 of Civil Services (Prelim) Examination for the purpose of evaluation. Therefore a 
                                 candidate will be disqualified in case he/she does not appear in both the papers of Civil Services (Prelim).</p>
                                <p className="">Note 3: Appearing in any one of the papers on the examination day will be counted as an attempt.</p>
                                <p className="">Note 4: If a candidate has applied but not appeared for the examination, it will not be counted as an attempt.</p>
                            </div>
                        </div>
                   </div>

                   <div className="container">
                        <div className="row">
                            <div className="col">
                                <h2 className={`${styles.sectiontitle} mb-0`}>Civil Service Mains Examinations</h2>
                                    <p className={`${styles.aboutheading1} mb-0 pt-md-2`}>Paper I</p>
                                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan} d-inline`}>
                                                Essay : Candidates will be required to write essays on specific topics given in the examination.
                                                </p>
                                            </div>
                                        </li>

                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan} d-inline`}>
                                                They will be expected to keep closely to the subject of the essay to arrange their ideas in an orderly fashion and to write concisely. Credit will be given for effective and exact expression.
                                                </p>
                                            </div>
                                        </li>


                                    </ul>



                                    <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper II - General Studies - I</p>
                                    <p className={`${styles.aboutheading2}`}>Indian Heritage and Culture, History and Geography of the World and Society of India.</p>

                                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                       {thirdlist.map((item,index)=>(
                                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                                    <div className="d-inline">
                                                        <p className={`${styles.ullispan} d-inline`}>
                                                        {item.list}
                                                        </p>
                                                    </div>
                                             </li>
                                        ))}
                                    </ul>


                                    <p className={`${styles.aboutheading1} pt-3 mb-0`}>Paper III - General Studies - II</p>
                                    <p className={`${styles.aboutheading2}`}>Governance, Constitution, Polity, Social Justice and International relations.</p>
                                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                        {fourthlist.map((item,index)=>(
                                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                                <div className="d-inline">
                                                    <p className={`${styles.ullispan} d-inline`}>
                                                {item.list}
                                                    </p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>




                                    <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper IV - General Studies - III</p>
                                    <p className={`${styles.aboutheading2}`}>Technology, Economic Development, Bio-diversity, Environment, Security and Disaster Management.</p>
                                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                        {fifthlist.map((item,index)=>(
                                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                                <div className="d-inline">
                                                    <p className={`${styles.ullispan} d-inline`}>
                                                    {item.list}
                                                    </p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>



                                    <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper V - General Studies - IV</p>
                                    <p className={`${styles.aboutheading2}`}>Ethics, Integrity, and Aptitude</p>
                                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan} d-inline`}>
                                                This paper will include questions to test the candidates’ attitude and approach to issues relating to integrity, probity in public life and his problem solving approach to various issues and conflicts faced by him in dealing with society. Questions may utilize the case study approach to determine these aspects. The following broad areas will be covered.
                                                </p>
                                            </div>
                                        </li>
                                    </ul>


                                    <p className={`${styles.aboutheading2}`}>Ethics and Human Interface</p> 
                                    <p className={`${styles.acheiverrank}`}>Essence, determinants and consequences of Ethics in human actions; dimensions of ethics; ethics in private and public relationships. Human Values – lessons from the lives and teachings of great leaders, reformers and administrators; role of family, society and educational institutions in inculcating values.</p>

                                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                        {sixthlist.map((item,index)=>(
                                            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                                <div className="d-inline">
                                                    <p className={`${styles.ullispan} d-inline`}>
                                                   {item.list}
                                                    </p>
                                                </div>
                                           </li>
                                        ))}  
                                    </ul>




                                    <p className={`${styles.aboutheading1} mb-0 pt-3`}>Paper - VI & Paper VII</p>
                                    <p className={`${styles.aboutheading2}`}>Optional Subject : Papers I and II</p>

                                    <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan} d-inline`}>
                                                Candidates may choose any optional subject from amongst the list of subjects given in the UPSC Notification.
                                                </p>
                                            </div>
                                        </li>

                                        <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan} d-inline`}>
                                                For UPSC notification and optional subject list visit IAS Parliament website (www. iasparliament.com).
                                                </p>
                                            </div>
                                        </li>


                                    </ul>


                            </div>
                        </div>
                   </div>
</>
  )
}

export default About_Civil_Service;